import { Step4Wrapper } from './styled';
import { Route, Switch, useHistory } from 'react-router-dom';
import { Question } from './components/Question';
import { MedicalCondition } from './components/MedicalCondition';
import { updateQuiz } from '@Store/components/quiz/actions/quizAction';
import { useDispatch } from 'react-redux';
import { Medication } from './components/Medication';
import { getEventProperty } from '@Utilities/getEventProperty';
import { sendAmplitudeData } from '@Analytics/amplitude';

export const Step4 = () => {

  const history = useHistory();
  const dispatch = useDispatch();

  const handleRadioButton = event => {
    const { name, value } = event.target;
    let eventProperty = {};
    dispatch(
      updateQuiz({
        name,
        value,
      })
    );

    switch (name) {
      case 'medical-condition':
        eventProperty = getEventProperty('Step_4_9_medical_conditions_click', 'MedConditions', value);
        setTimeout(() => {
          history.push('medication');
        }, 300);
        break;
      case 'medication':
        eventProperty = getEventProperty('Step_4_10_Medications_click', 'Medications', value);
        setTimeout(() => {
          history.push('/quiz/good_hands');
        }, 300);
        break;
    }

    sendAmplitudeData(eventProperty.eventName, {
      [eventProperty.name]: eventProperty.value,
    });
  };
  return (
    <Step4Wrapper>
      <Switch>
        <Route exact path='/quiz/steps/question/:id'>
          <Question />
        </Route>
        <Route exact path='/quiz/steps/medical_condition'>
          <MedicalCondition subStepName='medical-condition' handleRadioButton={handleRadioButton} />
        </Route>
        <Route exact path='/quiz/steps/medication'>
          <Medication subStepName='medication' handleRadioButton={handleRadioButton} />
        </Route>
      </Switch>
    </Step4Wrapper>
  );
};
